import Vue from 'vue'
import VueMarkdown from 'vue-markdown'
import { mapGetters, mapActions } from 'vuex'
import textblockBase from '@/components/textblockBase.js'
// import anime from 'animejs'

// Directives
import inViewportDirective from 'vue-in-viewport-directive'
import VueParallaxJs from 'vue-parallax-js'

Vue.use(VueParallaxJs)
Vue.directive('in-viewport', inViewportDirective)

export default {
  props: [ 'payload' ],
  mixins: [ textblockBase ],
  components: { VueMarkdown },
  data () {
    return {
      link: this.payload && this.payload.fields.link,
      template: this.payload && this.payload.fields.templateId,
      classes: this.payload && this.payload.fields.classes,
      content: []
    }
  },
  watch: {
    // 'pages': function (data) { // watches for pages in store to be populated/changed
    //   this.update(data)
    // }
  },
  methods: {
    ...mapActions([
      'getContentTypes',
      'getEntries',
      'getEntry',
      'getAsset'
    ]),
    getSectionContent (data) {
      this.content = []
      data.forEach((n) => {
        this.content.push(n)
      })
    },
    kebabToCamel (s) {
      return s.replace(/(-\w)/g, m => m[1].toUpperCase())
    }
  },
  computed: {
    ...mapGetters([
      'domain',
      'pages'
    ])
  },
  created () {
    // this.setSectionInfo(this.payload.fields)
    this.payload.fields.content && this.getSectionContent(this.payload.fields.content)
  },
  updated () {
    this.payload.fields.content && this.getSectionContent(this.payload.fields.content)
  },
  mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/components/sections/sectionBase.js